import {parameters} from "@/constants/parameter-constants";

export const isLimitedParameter = (parameterCode) => {
    return (!!parameters[parameterCode] && parameters[parameterCode].values.length);
};

export const getParameterValues = (parameterCode) => {
    return parameters[parameterCode].values;
};